module.exports = __webpack_public_path__ + "static/media/washington-dc-61.a372746b.jpg";